@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/publish-tab/clipping-studio-publish-tab.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.publish-tab::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.publish-tab::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.publish-tab::-webkit-scrollbar-corner {
  background: transparent;
}
.publish-tab::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.publish-tab::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.publish-tab::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.publish-tab::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.publish-tab::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.publish-tab {
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-sizing: border-box;
  overflow-y: auto;
}
.publish-tab__ready-count {
  margin: 0;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 10px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
}
.publish-tab__warning {
  margin: 0;
  padding: 8px 10px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: rgb(163, 115, 0);
  border: 1px solid rgb(255, 180, 0);
  border-radius: 6px;
  background: rgba(255, 180, 0, 0.08);
}
.publish-tab__cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/*# sourceMappingURL=clipping-studio-publish-tab.component.css.map */
